/**
 * 字面量
 */
export const LITERAL = 1

/**
 * 标识符
 */
export const IDENTIFIER = 2

/**
 * 对象属性或数组下标
 */
export const MEMBER = 3

/**
 * 一元表达式，如 - a
 */
export const UNARY = 4

/**
 * 二元表达式，如 a + b
 */
export const BINARY = 5

/**
 * 三元表达式，如 a ? b : c
 */
export const TERNARY = 6

/**
 * 数组表达式，如 [ 1, 2, 3 ]
 */
export const ARRAY = 7

/**
 * 对象表达式，如 { name: 'yox' }
 */
export const OBJECT = 8

/**
 * 函数调用表达式，如 a()
 */
export const CALL = 9
